import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import EventFormModal from 'r/ui/EventFormModal';
import { fetchApiRaw, GET_EVENTS_PLAY } from 'r/utils/fetchApiRaw';
import type { SanseiEvent } from 'r/types';

export default function EventEditRoute() {
  const { eventId } = useParams<{ eventId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Look for event in existing cache (instant if coming from the list)
  const cachedEvent = queryClient
    .getQueriesData<{ data: SanseiEvent[] }>({ queryKey: ['cms-events-play'] })
    .flatMap(([, page]) => page?.data ?? [])
    .find((e) => e.id === eventId);

  // Fallback fetch by ID for direct links
  const { data: fetchedEvent } = useQuery({
    queryKey: ['event', eventId],
    queryFn: async () => {
      const response = await fetchApiRaw(GET_EVENTS_PLAY, {
        queryParams: {
          filter: encodeURIComponent(`"id":["${eventId}"]`),
          include: 'eventOutcomes',
          take: '1',
        },
      });
      const data = Array.isArray(response.data) ? response.data : [];
      return (data[0] as SanseiEvent) ?? null;
    },
    enabled: !cachedEvent && !!eventId,
    staleTime: 5 * 60 * 1000,
  });

  const event = cachedEvent ?? fetchedEvent ?? undefined;

  const handleClose = () => {
    if (location.state?.background) {
      navigate(-1);
    } else {
      navigate('/?tab=events');
    }
  };

  return (
    <EventFormModal
      mode="edit"
      event={event}
      isOpen={true}
      onClose={handleClose}
      onSuccess={() => {}}
    />
  );
}
